module.exports = "/fonts/iconsminds.eot?d9f93b8c66323ea4d837eb56d64564ca";